import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    textAlign: "center",
    padding: `${theme.spacing(4)}px ${theme.spacing(4)}px`,
    "& h6": {
      marginBottom: theme.spacing(1),
      fontSize: 18,
    },
    "& p": {
      fontSize: 13,
      lineHeight: 1.8,
    },
    "& a": {
      display: "block",
      width: "100%",
      marginTop: theme.spacing(2),
    },
    "& .MuiDivider-root": {
      width: "80%",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
  },
  profileCardImgWrap: {
    height: 70,
    width: 70,
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "center !important",
    marginBottom: theme.spacing(2),
    "& img": {
      width: "100%",
    },
  },
  icon: {
    color: theme.palette.primary.main,
    fontSize: 18,
    border: `1px solid ${theme.palette.primary.opacity}`,
    borderRadius: 30,
    padding: theme.spacing(0.6),
    minWidth: "unset",
    marginRight: theme.spacing(2),
  },
}));

export default useStyles;
